import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Images({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(ImagesStyled, {
    ...props,
    children
  });
}
const ImagesStyled = styled.div.withConfig({
  displayName: "ImagesStyled",
  componentId: "sc-v41o6p-0"
})(["display:grid;grid-template-rows:1fr 1fr;grid-template-columns:3fr 2fr;gap:", ";min-height:10px;&:has(:first-child:last-child){display:flex;}"], token.spacing1);
function Img({
  src,
  contentResize = "fill",
  alt = "",
  onError,
  ...props
}) {
  return /* @__PURE__ */ jsx(ImgStyled, {
    src,
    alt,
    $contentResize: contentResize,
    onError,
    ...props
  });
}
const ImgStyled = styled.img.withConfig({
  displayName: "ImgStyled",
  componentId: "sc-v41o6p-1"
})(["object-fit:", ";width:100%;height:100%;min-height:0;max-height:410px;&:nth-child(1){grid-row:1 / -1;grid-column:1;}&:nth-child(1):last-child{grid-column:span 2;}&:nth-child(2){grid-row:1;grid-column:2;}&:nth-child(2):last-child{grid-row:span 2;}&:nth-child(3){grid-row:2;grid-column:2;}"], (props) => props.$contentResize === "fill" ? "cover" : "scale-down");
export {
  Images,
  Img
};
//# sourceMappingURL=Images.js.map
